const AIMLAPI_KEY = import.meta.env?.VITE_AIMLAPI_KEY;
const AIMLAPI_BASE_URL = 'https://api.aimlapi.com/v1';

const hasValidKey = () => {
  if (!AIMLAPI_KEY) return false;
  const placeholders = ['your-aimlapi-key', 'your_api_key', 'placeholder', 'xxx', 'your-'];
  return !placeholders.some((p) => AIMLAPI_KEY.toLowerCase().includes(p));
};

const systemPrompt = `
You are an elite UGC coach. Produce tight, on-brand outputs for TikTok/IG Reels/YouTube Shorts.
Return concise hooks, script beats, shot lists, captions, and outreach copy. Avoid fluff.
`;

export async function generateUGCPlan(payload) {
  if (!hasValidKey()) {
    throw new Error('AI key is not configured');
  }

  const { brand, product, platform, tone, audience, goal, cta, hooks = 3 } = payload;

  const userPrompt = `
Brand: ${brand || 'Brand'}
Product/Offer: ${product || 'Product'}
Platform: ${platform}
Tone: ${tone}
Audience: ${audience || 'creators'}
Goal: ${goal}
CTA: ${cta || 'Shop now'}
Hook variations: ${hooks}

Return JSON with:
{
  "hooks": ["...", "..."],
  "script": [{"label": "Hook", "copy": "..."}, ...],
  "shotList": [{"shot": "...", "framing": "...", "action": "...", "text": "..."}],
  "platformNotes": ["...", "..."]
}
Keep it short and shootable.`;

  const response = await fetch(`${AIMLAPI_BASE_URL}/chat/completions`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${AIMLAPI_KEY}`
    },
    body: JSON.stringify({
      model: 'gpt-4o-mini',
      messages: [
        { role: 'system', content: systemPrompt },
        { role: 'user', content: userPrompt }
      ],
      temperature: 0.5,
      max_tokens: 800
    })
  });

  if (!response.ok) {
    const text = await response.text();
    throw new Error(`AI request failed: ${text}`);
  }

  const data = await response.json();
  const raw = data?.choices?.[0]?.message?.content;
  let parsed;
  try {
    parsed = JSON.parse(raw);
  } catch (err) {
    throw new Error('AI response parsing failed');
  }
  return parsed;
}
